/* eslint-disable import/prefer-default-export */
import { createActions } from 'redux-actions';

const { toggleMapVisibility } = createActions({
	TOGGLE_MAP_VISIBILITY: () => ({})
});

export { toggleMapVisibility };
